import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/system";
import CropRotateIcon from "@mui/icons-material/CropRotate";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import { useMediaQuery } from "@mui/material";
// import Investtab from "./Investtab";
import { FormControlLabel } from "@mui/material";
import ImageUploading from "react-images-uploading";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { useParams } from "react-router-dom";
import "./../style.css";
import "./../create.css";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { basic, complex, formatting } from "../../misc/buttonList.js";

import { Row, Col } from "reactstrap";
// Import Swiper styles
// import 'swiper/css';
import {
  Container,
  FormControl,
  Input,
  InputAdornment,
  InputBase,
  InputLabel,
  Paper,
  TextField,
  Typography,
  Button,
} from "@mui/material";



import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { updateTockenomics } from "../../../redux/actions/Tokenomics_action.js";

// import { getNftPopularRefresh } from "../../../redux/actions/adminDash_action.js";

import API from "../../../redux/url.js";
import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const TokenomicsUpdate = () => {
  const params = useParams();
  const dispatch = useDispatch();

  // const [EditRecordBefore, setEditRecordBefore] = useState("");
  const [record, setrecord] = useState(false);
  const [idtoUpdate, setidtoUpdate] = useState(false);

  console.log("myid");
  console.log(params.id);



  const [description, setDescription] = useState(null);

  const isTockenomicsUpdated = useSelector(
    (state) => state.TockenomicsReducer.isTockenomicsUpdated
  );

  console.log("isTockenomicsUpdated");
  console.log(isTockenomicsUpdated);

    const [state, setState] = useState({
      title: "",
      per: "",
      rdc: "",
    });

  useEffect(() => {
    // dispatch(getsocial());
    // await axios.get('https://httpbin.org/get', { params });

    axios.get(API + "/gettockenomicsByid", { params }).then((res) => {
      console.log("gettockenomicsByid.data", res.data);
      console.log(res.data.user);

      console.log('res.data.user');

       setidtoUpdate(res.data.user[0]._id);



      setrecord(res.data.user);

      setState({
        title: res.data.user[0].title,
        per: res.data.user[0].per,
        rdc: res.data.user[0].rdc,
      });

      // setDescription(res.data.user[0].description);

   
      // setEditRecordBefore(res.data.user[0]);
    });
  }, [isTockenomicsUpdated]);

  console.log("record");
  console.log(idtoUpdate);


  const filesstyle = {
    color: "black",
    border: "1px black solid",
    width: "100%",
    background: "white",
    height: "36px",
    padding: "7px",
    border: "1px solid rgb(190, 194, 199)",
    borderRadius: "7px",
    marginBottom: "20px",
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
  };

  const labls = {
    color: "#101924",
    flex: "1",
    marginLeft: "2px",
  };

  const errmsg = {
    color: "red",
    position: "relative",
    top: "-11px",
  };

  const inputstyle = {
    padding: "3px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    border: "1px solid #bec2c7",
    borderRadius: "7px",
    marginBottom: "20px",
  };

  const check = useMediaQuery("(max-Width:900px)");

  const [titleerr, settitleerr] = useState("");
  const [pererr, setpererr] = useState("");
  const [rdcerr, setrdcerr] = useState("");



  const onChangeHandler = (e) => {
    if (e.target.name == "image") {
      let val = e.target.files[0];
      setState({ ...state, [e.target.name]: val });
    } else {
      setState({ ...state, [e.target.name]: e.target.value });
    }
  };

  const editorRef = useRef < SunEditor > null;
  useEffect(() => {
    // Get underlining core object here
    // Notice that useEffect is been used because you have to make sure the editor is rendered.
    console.log(editorRef.current?.editor.core);
  }, []);

  const handleChange = (content) => {
    setDescription(content); //Get Content Inside Editor
  };

  const onSubmit = (e) => {
    e.preventDefault();
    let obj = {
      ...state,
      idtoUpdate,
    };

    // var isFormvalid = validate();
    // console.log("isvalid", isFormvalid);
    window.scrollTo(0, 200);

    if (description) obj.description = description;

    if (validate()) {
      console.log(obj);
      dispatch(updateTockenomics(obj));
      //  alert("ok");
    }
  };

 const validate = () => {
   console.log("validate called");
   let isvalid = true;

   if (
     state.title.length < 5 ||
     state.title.length > 50 ||
     state.title.length == 0
   ) {
     isvalid = false;
     settitleerr("title to be 5 to 50 characters long");
     setpererr("");
     setrdcerr("");
   } else if (state.per.length == 0) {
     isvalid = false;
     settitleerr("");
     setpererr("Percentage Should Not Empty!");
     setrdcerr("");
   } else if (state.rdc.length == 0) {
     isvalid = false;
     settitleerr("");
     setpererr("");
     setrdcerr("RDC Points Should Not Empty!");
   } else {
     settitleerr("");
     setpererr("");
     setrdcerr("");
   }

   return isvalid;
 };
  // const SubmitData = (e) => {
  //   e.preventDefault();

  //   window.scrollTo(0, 200);
  //     // dispatch(setNftPopular(images));
  //      const formData = new FormData();
  //       formData.append('title', state.title);
  //       for (let i = 0; i < multipleFiles.length; i++) {
  //           formData.append('files', multipleFiles[i]);
  //       }
  //       await multipleFilesUpload(formData, mulitpleFileOptions);
  //       props.getMultiple();

  // };

  return (
    <div className="content-wrapper">
      <div
        id="order_preview"
        className="wow fadeInUp content_box"
        style={{ visibility: "visible", animationName: "fadeInUp" }}
      >
        <Row classNameName="table-header">
          <Col xs="12" md="12">
            <h2 className="section-title" style={{ color: "black" }}>
              Update Your Tockenmics
            </h2>
          </Col>
        </Row>
        <div className="row">
          <Row>
            <Col xs="12" md="9">
              {record ? (
                <div>
                  {record.map((item, index) => {
                    return (
                      <form>
                        <div class="form-group">
                          <label for="pwd">Tokenomics Title</label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            name="title"
                            onChange={onChangeHandler}
                            defaultValue={state.title}
                          />
                          <center>
                            {titleerr ? (
                              <div style={errmsg}>{titleerr}</div>
                            ) : null}
                          </center>
                        </div>

                        <div class="form-group">
                          <label for="pwd"> Tokenomics Percentage(%) </label>
                          <input
                            name="per"
                            type="number"
                            class="form-control"
                            required
                            onChange={onChangeHandler}
                            defaultValue={state.per}
                          />
                          <center>
                            {pererr ? <div style={errmsg}>{pererr}</div> : null}
                          </center>
                        </div>

                        <div class="form-group">
                          <label for="pwd"> Tokenomics RDC Points </label>
                          <input
                            name="rdc"
                            type="number"
                            class="form-control"
                            required
                            onChange={onChangeHandler}
                            defaultValue={state.rdc}
                          />
                          <center>
                            {rdcerr ? <div style={errmsg}>{rdcerr}</div> : null}
                          </center>
                        </div>

                        {/* 
                <div class="form-group">
                  <label for="pwd">Service Image </label>
                  <input
                    type="file"
                    class="form-control"
                    required
                    name="image"
                    onChange={onChangeHandler}
                  />
                </div> */}

                        <button
                          type="submit"
                          class="btn btn-default"
                          onClick={onSubmit}
                          style={{
                            marginTop: 10,
                            float: "right",
                            padding: "8px 16px",
                            fontSize: 16,
                          }}
                        >
                          Update Tokenomics
                        </button>
                      </form>
                    );
                  })}
                </div>
              ) : (
                <div>Loading...</div>
              )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default TokenomicsUpdate;
